import {combineReducers} from 'redux'
import dashboard from './dashboard/reducer'
import authorizationInfo from './authorizationInfo/reducer'

export default (initAppData) => combineReducers({
    dashboard,
    authorizationInfo: authorizationInfo(initAppData),
})


// WEBPACK FOOTER //
// ./web/js/reports/reducer.js